var path = 'account/account.tpl.html';
var html = "<react-component name='settings' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;